// import NewsroomListing from "./NewsroomListing.jsx";
// import { PRESS_COVERAGE } from "../data/News.js";

// /**
//  * ASSOCHAM — Newsroom / Press Coverage
//  * How national and global media report on ASSOCHAM's advocacy.
//  */
// export default function PressCoverage() {
//   return (
//     <NewsroomListing
//       // eyebrow="In the News"
//       titleA="Press"
//       titleB="Coverage"
//       // description="A curated watch of how India's leading dailies, business channels and wire services report on ASSOCHAM's policy advocacy, surveys and interventions across sectors."
//       items={PRESS_COVERAGE}
//       // listTitle="Press Coverage"
//       showSource={true}
//     />
//   );
// }




// new new code 




import { useEffect, useState } from "react";
import NewsroomListing from "./NewsroomListing.jsx";
import { fetchPressCoverages } from "./pressCoverageApi.js";

export default function PressCoverage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchPressCoverages()
      .then((data) => alive && setItems(data))
      .catch((err) => alive && setError(err.message))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  if (loading) {
    return (
      <div className="min-h-[60vh] grid place-items-center bg-cream">
        <p className="text-[13px] font-bold text-mute animate-pulse">Loading press coverage…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-[60vh] grid place-items-center bg-cream">
        <p className="text-[13px] font-bold text-brand">Couldn't load press coverage: {error}</p>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="min-h-[60vh] grid place-items-center bg-cream">
        <p className="text-[13px] font-bold text-mute">No press coverage found.</p>
      </div>
    );
  }

  return (
    <NewsroomListing
      titleA="Press"
      titleB="Coverage"
      items={items}
      showSource={true}
    />
  );
}